module.exports = __webpack_public_path__ + "img/icon_tab_all_on.fafaa1d1.svg";